// Report.js
import React from "react"
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer"
import { getDateFn, getOrdQty } from "./ReportUtility.js"


const border_color = "#2f2e2e"
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',

  },
  section: {
    fontFamily: 'Helvetica',
    margin: 20,
    padding: 0,
    flexGrow: 1,
    fontSize: "9px",

    borderColor: "#475569"
  },

  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
    width: "100%"

  },
  tableColHeader: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    lineHeight: "1.5"
  },
  tableCol: {
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderColor: border_color,
    padding: "2",
  },
  tableCell: {
    padding: 4,
  },
  colWidth_lg: {
    width: '60%',

  },
  colWidth_sm: {
    width: '40%'
  },

  colMid: {
    padding: "0px 3px 0px 3px"
  },

  fontBold: {
    fontSize: "9px", fontFamily: 'Helvetica-Bold',
  },
  formHead: {
    fontSize: "12px", fontFamily: 'Helvetica-Bold',
    textTransform: "uppercase", padding: "2px", textAlign: "center", border: "1px",
    borderColor: border_color, fontSize: "11px",
  },
  tableTopBorder: {
    borderTop: 1,
    borderColor: border_color,
  },
  tableBottomBorder: {
    borderBottom: 1,
    borderColor: border_color,
  },
  tableHeading: {
    fontSize: "13px",
    textTransform: "uppercase",
    textAlign: "center",
    fontFamily: 'Helvetica-Bold'
  },
  colWidth: {
    width: "80%",
    textAlign: "left",
  },
  colWidth_label: {
    textAlign: "right",
    width: "30%",
    fontFamily: 'Helvetica-Bold',
    fontSize: "9px",
    whiteSpace: "nowrap"
    
  },
  footerText: {
    fontSize: "8px",
    fontWeight: 600,
    textTransform: "uppercase",
    fontFamily: 'Helvetica-Bold'
  },
  tblBorderLeft: {
    borderLeftWidth: 1
  },
  tblBorderRight: {
    borderRightWidth: 1
  }

})

// Create PDF component
const RptSaleOrderForm = ({ data }) => {

  return (
    <Document pageMode="fullScreen">
      <Page size="A4" style={styles.page}>
        {data && data.map((item, index) => {
          return (
            <>
              <View style={styles.section}>
                {/* HEader */}
                <View style={[styles.table]}>
                  <View style={[styles.tableRow, styles.tableTopBorder, styles.tblBorderLeft, styles.tblBorderRight]}>
                    <View style={[styles.tableCol, { minHeight: '60px', textAlign: "center", width: "100%" }]}>
                      <Text style={[styles.tableCell, styles.tableHeading]}>{item?.CompName}</Text>
                      <Text style={{lineHeight:1}}>{item?.Comp_Add1 +
                        " " +
                        item?.Comp_Add2 +
                        " " +
                        item?.Comp_Add3 +
                        " " +
                        item?.Comp_Add4 +
                        " " +
                        item?.Comp_City +
                        " " +
                        item?.Comp_State
                      }</Text>

                      <Text style={{width:"100%",paddingTop:"5px"}}>{`Contact No: ${item?.Comp_ContectNo1 || ''}  ${item?.Comp_ContectNo2 || ''} Email Id: ${item?.Comp_Email}`}</Text>
                    </View>
                  </View>
                </View>
                <View style={[styles.formHead]}>
                  <Text>Sales Order Form</Text>
                </View>
                <View style={[styles.table, styles.tblBorderLeft, styles.tblBorderRight,]}>
                  <View style={[styles.tableRow]}>
                    <View style={[styles.tableCol, styles.colWidth_lg]}>
                      <View style={[styles.table, { width: "100%" }]}>
                        <View style={[styles.tableRow]}>

                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>Customer</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth]}>
                            <Text style={styles.tableCell}>{item.PartyName}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>

                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>Broker</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth, {}]}>
                            <Text style={styles.tableCell}>{item?.BrokerName || ' '

                            } </Text>
                          </View>

                        </View>
                        <View style={[styles.tableRow]}>

                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>Item / Quality</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth]}>
                            <Text style={styles.tableCell}>{item?.ItemName || ""}</Text>
                          </View>

                        </View>

                      </View>
                    </View>
                    <View style={[styles.tableCol, styles.colWidth_sm]}>
                      <View style={[styles.table, { width: "100%" }]}>
                        <View style={[styles.tableRow]}>

                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>Date</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth]}>
                            <Text style={styles.tableCell}>{getDateFn(item.Ord_Date)}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>

                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>Order No</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth, {}]}>
                            <Text style={styles.tableCell}>{item?.Ord_No || ' '

                            } </Text>
                          </View>

                        </View>


                      </View>
                    </View>
                  </View>
                </View>
                <View style={[styles.table, styles.tblBorderLeft, styles.tblBorderRight, styles.tableTopBorder]}>
                  <View style={[styles.tableRow]}>
                    <View style={[styles.tableCol, { width: "40%" }]}>
                      <View style={[styles.table, { width: "100%" }]}>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>Challan</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth]}>
                            <Text style={styles.tableCell}>{item?.OChallan || ''}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>Order Qty</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth]}>
                            <Text style={styles.tableCell}>{`${item?.Meter ||''} Mtr.`}</Text>
                            {/* //getOrdQty(item?.QtyPer || '', item?.Meter || '', item?.Weight || '', item?.Pcs || '' */}
                          </View>
                        </View>
                        <View>
                        </View>
                      </View>
                    </View>
                    <View style={[styles.tableCol, { width: "40%" }]}>
                      <View style={[styles.table, { width: "100%" }]}>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>Range</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth]}>
                            <Text style={styles.tableCell}>{item?.OMtrRange || ''}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.colWidth_label ,{width:"35%"}]}>
                            <Text style={styles.tableCell}>Rate / Meter</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth]}>
                            <Text style={styles.tableCell}>{item?.Rate || ''}</Text>
                          </View>
                        </View>
                        <View>
                        </View>
                      </View>
                    </View>
                    <View style={[styles.tableCol, { width: "20%" },]}>
                      <View style={{ width: "100%", marginTop: "10px", flexDirection: "row" }}>
                        {item?.Disc_Per>0?<>
                        <Text style={[styles.fontBold]}>Disc % : </Text>
                        <Text>{item?.Disc_Per || ''}</Text></>:""}
                       
                      </View>
                      <View style={{ width: "100%", marginTop: "10px", flexDirection: "row" }}><Text >Payment Due: </Text>
                        <Text style={[styles.fontBold]}>{item?.Due_Days || ''}</Text>
                        <Text>{item?.Due_Days != "0" ? " Days" : ""}</Text>
                      </View>
                    </View>
                  </View>
                </View>
                <View style={[styles.tableTopBorder, styles.tblBorderLeft, styles.tblBorderRight, { padding: "5px", flexDirection: "row", width: "100%", lineHeight: 5 }]}>
                  <Text style={[styles.fontBold]}>Remark:</Text><Text>{item?.Remark || ''}</Text>
                </View>
                <View style={[styles.table, styles.tblBorderLeft, styles.tblBorderRight, styles.tableBottomBorder, { padding: "10px" }]}>
                  <View style={[styles.tableRow, styles.fontBold]}>
                    <View style={[styles.tableCol, { width: "50%" ,textAlign:"left"}]}>
                      <Text>Customer's Signature  ____________________________</Text>
                    </View>
                    <View style={[styles.tableCol, { width: "50%",textAlign:"right" }]}>
                      <Text>Authorised Signatory  ____________________________</Text>
                    </View>
                  </View>
                </View>
              </View>
            </>
          )
        })}
      </Page>
    </Document>
  )
}
export default RptSaleOrderForm
